import ImageOne from "../../Images/image1.jpg";
import ImageTwo from "../../Images/image2.jpg";
import ImageThree from "../../Images/image3.jpg";
import ImageFour from "../../Images/image4.jpg";

const projects = [
  {
    name: "IoT Smart Healthcare System",
    category: "IOT & MACHINE LEARNING",
    image: ImageOne,
    description:
      "A cardiovascular monitoring system using ESP32, AD8232, and MAX30102 sensors with a modified TabNet model that achieved 94.10% accuracy.",
    technologies: "PyTorch · TensorFlow · Flask · MQTT",
    link: "https://github.com/N-rahul-35/Final-year-project",
    action: "View code",
  },
  {
    name: "Street Light Fault Prediction",
    category: "MACHINE LEARNING",
    image: ImageTwo,
    description:
      "A TensorFlow-based fault prediction model that achieved 85% accuracy and supports more efficient street-light maintenance.",
    technologies: "Python · TensorFlow · Flask",
    link: "https://github.com/itb074/street_light_fault_prediction",
    action: "View code",
  },
  {
    name: "Mini Plant Store",
    category: "FULL-STACK DEVELOPMENT",
    image: ImageThree,
    description:
      "A MERN application for adding plants, searching by name, and viewing plant details, backed by MongoDB Atlas.",
    technologies: "MongoDB · Express · React · Node.js",
    link: "https://mini-plant-store-frontend-oqke.onrender.com/",
    action: "View project",
  },
  {
    name: "Underwater Object Detection",
    category: "COMPUTER VISION RESEARCH",
    image: ImageFour,
    description:
      "Object detection on the URPC2020 dataset using image enhancement, Faster R-CNN, and YOLOv8, reaching 79% mAP.",
    technologies: "YOLOv8 · Faster R-CNN · ResNet-50",
    link: "https://github.com/N-rahul-35/Object-Detection",
    action: "View research",
  },
];

function ProjectContent({ project, index }) {
  return (
    <>
      <div className="project-image">
        <img
          src={project.image}
          alt={`${project.name} project preview`}
          loading="lazy"
        />
        {project.link && (
          <span className="project-arrow" aria-hidden="true">
            ↗
          </span>
        )}
      </div>
      <div className="project-meta">
        <p className="eyebrow">{project.category}</p>
        <span>0{index + 1}</span>
      </div>
      <h2>{project.name}</h2>
      <p>{project.description}</p>
      <p className="project-tech">{project.technologies}</p>
      {project.link && <span className="text-link">{project.action} ↗</span>}
    </>
  );
}

export default function Portfolio() {
  return (
    <section className="inner-page">
      <p className="eyebrow">SELECTED WORK</p>
      <h1>
        Ideas turned into
        <br />
        <span>real projects.</span>
      </h1>
      <p className="page-description">
        A collection of my work across full-stack development, machine learning,
        computer vision, and IoT.
      </p>
      <div className="project-grid">
        {projects.map((project, index) =>
          project.link ? (
            <a
              className="project-card"
              href={project.link}
              target="_blank"
              rel="noreferrer"
              key={project.name}
            >
              <ProjectContent project={project} index={index} />
            </a>
          ) : (
            <article className="project-card" key={project.name}>
              <ProjectContent project={project} index={index} />
            </article>
          ),
        )}
      </div>
    </section>
  );
}
